import React, { useEffect, useState, useRef } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col } from 'antd';
import { useNavigate } from "react-router-dom";
import Header from '../common/header'
import CreateUserModal from "./modals/create-user";
import ManageIntervalsModal from "./modals/manage-intervals";
import createUser from "../common/helpers/create-user";
import updateUser from "../common/helpers/update-user";
import fetchUsers from "../common/helpers/fetch-users";
import deleteUser from "../common/helpers/delete-user";
import { useAppContext, APP_ACTIONS } from "../../context/appContext";
import fetchProfiles from '../common/helpers/fetch-profiles';
import fetchBots from "../common/helpers/fetch-bots";
import createProfile from "../common/helpers/create-profile";
import deleteProfile from "../common/helpers/delete-profile";
import moment from "moment";
import terminateServer from "../common/helpers/terminate-server";
import fetchUnprocessedOrders from "../common/helpers/fetch-unprocessed-orders";
import createUnprocessedOrders from "../common/helpers/create-unprocessed-orders";
import createUnprocessedAccumulators from "../common/helpers/create-unprocessed-accumulators";
import { CloseOutlined } from '@ant-design/icons';
const { Option } = Select;
const { TabPane } = Tabs;


const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }
const tableRowStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", paddingLeft: 20 }

const User = ({ hasAuth, changeRemoteHost, setRestartData }) => {
    const {
        state: { profiles, bots, users },
        dispatch,
    } = useAppContext();
    const inputFile = useRef(null) 
    const [displayCreateUser, setDisplayCreateUser] = useState(false);
    const [displayDeleteUser, setDisplayDeleteUser] = useState(false);
    const [userList, setUserList] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [displayManageIntervals, setDisplayManageIntervals] = useState(false);
    const [displayWarning, setDisplayWarning] = useState(false);
    const [backup, setBackup] = useState(false);
    const [fileContent, setFileContent] = useState("");
    const [disableButton, setDisableButton] = useState(false);
    useEffect(() => {
        fetchUsers().then(res => {
            if (Array.isArray(res)) {
                setUserList(res)
            }
        })
    }, [hasAuth, changeRemoteHost])

    // useEffect(() => {
    //     if(inputFile) {

    //         const files = inputFile.current.files;

    //         console.log({files})
    //         if (files.length <= 0) {
    //           return false;
    //         }

    //         const filesJSON = Array.from(e.target.files)
    //         console.log("files:", filesJSON)
          
    //         // let fr = new FileReader();
          
    //         // fr.onload = function(e) { 
    //         // console.log(e);
    //         //   let result = JSON.parse(e.target.result);
    //         //   let formatted = JSON.stringify(result, null, 2);
    //         //   console.log({formatted})
    //         // }
          
    //     }
    // }, [inputFile])

    const sleep = (ms) => {
        return new Promise((resolve) => setTimeout(resolve, ms));
    };

    const readFile = async (event) => {
        try {
            const fileReader = new FileReader();
            const { files } = event.target;
        
            fileReader.readAsText(files[0], "UTF-8");
            fileReader.onload = async (e) => {
                try {
                    const content = e.target.result;
    
                    let parsed = JSON.parse(content);
          
                    if (!parsed) {
                      message.error('Error: File could not be read');
                      setBackup(false);
                    }
      
                    for(const data of parsed) {
          
                      const orders = data.strategies;
                      if (Array.isArray(orders?.data)) {
                          const unProcessedOrders = orders?.data;
                          unProcessedOrders.forEach(order => { delete order.logs; delete order.expanded; delete order.saved; })
                    
                          await createUnprocessedOrders(unProcessedOrders)
                      }
          
                      const accumulators = data.accumulators;
          
                      if (Array.isArray(accumulators?.data)) {
                          const unProcessedOrders = accumulators?.data;
                          unProcessedOrders.forEach(accumulator => { delete accumulator.logs; delete accumulator.expanded; delete accumulator.saved; })
          
                          await createUnprocessedAccumulators(unProcessedOrders)
                      }
                    }
                    setDisableButton(true)
                    message.loading({ content: 'Waiting...', key: 'restore', duration: 0 });
                    await sleep(3*1000)
                    setDisableButton(false)
                    setRestartData(prev => !prev);
                    message.destroy('restore');
                    message.success('Strategies restored');
                    setBackup(false);

                } catch (error) {
                    message.error(error.message);
                }
           

            };
        } catch (error) {
            message.error(error.message);
        }
      };

    const validateEmail = (email) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };

    const handleUserCreate = async (data, action) => {
        try {
            const { email, password, password2, activated, bot_limit, strategy_limit } = data;

            if (!validateEmail(email)) {
                message.error("invalid email");
                return;
            }
            if (action === 'create' && !password) { message.error("Please enter password"); return; };

            if (password !== password2) {
                message.error("passwords don't match")
                return;
            }
            let apiAction = createUser;
            if (action === 'update') apiAction = updateUser;
            if (data.bot_limit) data.bot_limit = parseInt(data.bot_limit)
            if (data.strategy_limit) data.strategy_limit = parseInt(data.strategy_limit)
            const res = await apiAction(data);
            if (res.error) {
                message.error(res.error)
                return;
            }
            fetchUsers().then(res => {
                if (Array.isArray(res)) {
                    setUserList(res)
                    message.success("Changes Saved");
                }
            })
            setDisplayCreateUser(false);
            setSelectedUser(null);
        } catch (err) {
            message.error(err.message);
        }
    }

    const handleDelete = async () => {
        const res = await deleteUser(deleteUserId);
        if (res.error) {
            message.error(res.error)
            return;
        }
        message.success("Changes Saved");
        fetchUsers().then(res => {
            if (Array.isArray(res)) {
                setUserList(res)
            }
        })

        setDisplayDeleteUser(false);
    }

    const calculateActiveBots = (bots) => {
        let activeBots = 0;
        bots.forEach(bot => {
            if (bot.active) {
                activeBots++;
            }
        })
        return activeBots;
    }

    const downloadStrategies = async () => {

        try {
            fetchUnprocessedOrders().then(res => {
                if (Array.isArray(res)) {
    
                    // let orders = [];
                    // for (let bot of res) {
                    //     if (bot?.strategies?.data) {
                    //         orders = [...orders, ...bot.strategies.data];
                    //     }
                    // }
    
                    // orders.forEach(order => {
                    //     order.logs = [];
                    //     order.saved = true;
                    //     order.expanded = false;
                    // })
    
                    // let accumulators = [];
                    // for (let bot of res) {
                    //     if (bot?.accumulators?.data) {
                    //         accumulators = [...accumulators, ...bot.accumulators.data];
                    //     }
                    // }
    
                    // accumulators.forEach(order => {
                    //     order.logs = [];
                    //     order.saved = true;
                    //     order.expanded = false;
                    // })
    
                    // create file in browser
                    const fileName = "strategies_backup";
                    const json = JSON.stringify(res, null, 2);
                    const blob = new Blob([json], { type: "application/json" });
                    const href = URL.createObjectURL(blob);
    
                    // create "a" HTLM element with href to file
                    const link = document.createElement("a");
                    link.href = href;
                    link.download = fileName + ".json";
                    document.body.appendChild(link);
                    link.click();
    
                    // clean up "a" element & remove ObjectURL
                    document.body.removeChild(link);
                    URL.revokeObjectURL(href);
    
                }
            })
        } catch (error) {
            message.error(error.message);
        }
     
    }

    const onButtonClick = () => {
        inputFile.current.click();
      };


    return (
        <>
            {displayCreateUser && <CreateUserModal displayCreateUser={displayCreateUser} setDisplayCreateUser={setDisplayCreateUser} onUserCreate={handleUserCreate} selectedUser={selectedUser} setSelectedUser={setSelectedUser} />}
            {displayManageIntervals && <ManageIntervalsModal displayManageIntervals={displayManageIntervals} setDisplayManageIntervals={setDisplayManageIntervals} />}

            <Modal bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
                visible={displayWarning} footer={null} onCancel={() => { setDisplayWarning(false); }}>

                <div style={{ fontWeight: "600", color: "white" }}>Terminate the server</div>
                <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                    Are you sure you want to terminate the server that you are connected to ?
                </div>


                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button onClick={() => { setDisplayWarning(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NO</Button>
                    <Button onClick={() => {
                        terminateServer().then(res => {
                            if (res.error) {
                                message.error('Operation not successful. Something went wrong');
                            } else {
                                message.success('Server Terminated');
                            }
                        })
                        setDisplayWarning(false);
                    }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">YES</Button>
                </div>
            </Modal>

            <Modal 
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
                visible={backup} footer={null} onCancel={() => { setBackup(false); }}>

                <div style={{ fontWeight: "600", color: "white" }}>Backup or Restore</div>
                <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                   You can download all your strategies or restore strategies from a downloaded backup
                </div>
                <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                    <Button disabled={disableButton} onClick={() => { downloadStrategies() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">DOWNLOAD ALL YOUR STRATEGIES</Button>
                    <Button disabled={disableButton} onClick={() => { onButtonClick() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">RESTORE A BACKUP</Button>
                </div>
            </Modal>

            {displayDeleteUser &&
                <Modal bodyStyle={{
                    backgroundColor: 'black',
                    border: "1px solid grey"
                }}
                    visible={displayDeleteUser} footer={null} onCancel={() => { setDisplayDeleteUser(false); }}>

                    <div style={{ fontWeight: "600", color: "white" }}>Delete User</div>
                    <div style={{ color: "grey", marginTop: 20, marginBottom: 40 }}>
                        Are you sure you want to delete this user?
                    </div>


                    <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                        <Button onClick={() => { setDisplayDeleteUser(false); }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">NO</Button>
                        <Button onClick={() => {
                            handleDelete();
                        }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">YES</Button>
                    </div>
                </Modal>
            }




            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="70.502" height="70.502" viewBox="0 0 70.502 70.502">
                            <path id="Path_5812" data-name="Path 5812" d="M248.123,164.322a13.809,13.809,0,1,0,13.81,13.808A13.824,13.824,0,0,0,248.123,164.322Zm0,23.3a9.49,9.49,0,1,1,9.491-9.491A9.5,9.5,0,0,1,248.123,187.622Zm33.092-17.566H276.27a29.014,29.014,0,0,0-2.537-6.111l3.5-3.5a2.159,2.159,0,0,0,0-3.054l-8.369-8.369a2.162,2.162,0,0,0-3.055,0l-3.5,3.5a29.042,29.042,0,0,0-6.111-2.54V145.04a2.159,2.159,0,0,0-2.159-2.159H242.205a2.158,2.158,0,0,0-2.159,2.159v4.943a28.945,28.945,0,0,0-6.112,2.54l-3.5-3.5a2.222,2.222,0,0,0-3.054,0l-8.367,8.367a2.159,2.159,0,0,0,0,3.054l3.5,3.5a29.134,29.134,0,0,0-2.54,6.112h-4.943a2.158,2.158,0,0,0-2.159,2.159v11.835a2.159,2.159,0,0,0,2.159,2.159h4.944a28.906,28.906,0,0,0,2.54,6.109l-3.5,3.5a2.159,2.159,0,0,0,0,3.054l8.369,8.369a2.159,2.159,0,0,0,3.054,0l3.5-3.5a29.015,29.015,0,0,0,6.109,2.538v4.947a2.159,2.159,0,0,0,2.159,2.159h11.833a2.159,2.159,0,0,0,2.159-2.159v-4.947a28.959,28.959,0,0,0,6.109-2.538l3.5,3.5a2.222,2.222,0,0,0,3.054,0l8.369-8.369a2.159,2.159,0,0,0,0-3.054l-3.5-3.5a29.161,29.161,0,0,0,2.54-6.109h4.944a2.159,2.159,0,0,0,2.159-2.159V172.213a2.158,2.158,0,0,0-2.159-2.157Zm-2.159,11.833h-4.462a2.158,2.158,0,0,0-2.108,1.69,24.789,24.789,0,0,1-3.291,7.919,2.159,2.159,0,0,0,.3,2.685l3.163,3.163-5.313,5.313-3.163-3.163a2.158,2.158,0,0,0-2.685-.3,24.757,24.757,0,0,1-7.921,3.29,2.159,2.159,0,0,0-1.69,2.108v4.465h-7.514V204.6a2.159,2.159,0,0,0-1.69-2.108,24.784,24.784,0,0,1-7.919-3.288,2.161,2.161,0,0,0-2.685.3l-3.164,3.163-5.315-5.315,3.163-3.163a2.158,2.158,0,0,0,.3-2.685,24.719,24.719,0,0,1-3.29-7.919,2.16,2.16,0,0,0-2.108-1.69h-4.462v-7.516h4.462a2.159,2.159,0,0,0,2.108-1.69,24.766,24.766,0,0,1,3.291-7.921,2.16,2.16,0,0,0-.3-2.686l-3.161-3.161,5.312-5.312,3.161,3.161a2.155,2.155,0,0,0,2.685.3,24.736,24.736,0,0,1,7.922-3.29,2.158,2.158,0,0,0,1.69-2.108V147.2h7.514v4.462a2.159,2.159,0,0,0,1.69,2.108,24.783,24.783,0,0,1,7.922,3.29,2.156,2.156,0,0,0,2.685-.3l3.161-3.161,5.313,5.313-3.161,3.161a2.16,2.16,0,0,0-.3,2.685,24.756,24.756,0,0,1,3.29,7.921,2.159,2.159,0,0,0,2.108,1.69h4.462Z" transform="translate(-212.872 -142.881)" fill="#fff" opacity="0.5" />
                        </svg>

                        <div>
                            <div style={{ color: "white", fontSize: 17, cursor: "default" }}>Admin Control Panel</div>
                            <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>Manage settings, Create and monitor users in this panel</div>
                            <div style={{ color: "#B4B4B4", fontSize: 13, cursor: "default" }}>To create a user, click <span style={{ textDecoration: "underline" }}>'NEW'</span> </div>
                        </div>

                    </div>
                    <div>
                        {/* <Button onClick={() => { setBackup(true); }} style={{ backgroundColor: "#161616", color: "white", height: 50, marginRight: 15 }} type="default">BACKUP/RESTORE</Button> */}
                        <Button onClick={() => { setDisplayWarning(true); }} style={{ backgroundColor: "#161616", color: "white", height: 50, marginRight: 15 }} type="default">TERMINATE</Button>
                        <Button onClick={() => { setDisplayManageIntervals(true); }} style={{ backgroundColor: "#161616", color: "white", height: 50, marginRight: 15 }} type="default">CONFIGURE SYSTEM INTERVALS</Button>
                        <Button onClick={() => { setDisplayCreateUser(true); }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">NEW USER</Button>
                    </div>
                </div>
                <div style={{ display: "flex", flexDirection: "row", height: "70%", width: "100%", padding: 10 }}>
                    <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                        <div style={{ maxHeight: 800, overflowY: "auto" }}>
                            <table style={{ width: "100%", }}>
                                <tr>
                                    <th style={tableHeaderStyle} >USER</th>
                                    <th style={tableHeaderStyle} >STATUS</th>
                                    <th style={tableHeaderStyle} >BOT CREATION LIMIT</th>
                                    <th style={tableHeaderStyle} >STRATEGY CREATION LIMIT PER BOT</th>
                                    <th style={tableHeaderStyle} >NUMBER OF ACTIVE BOTS</th>
                                    <th style={tableHeaderStyle} >ACTION</th>
                                </tr>


                                <input type='file' onChange={readFile} id='file' ref={inputFile} accept=".json" style={{display: 'none'}}/>
                                {userList.map(user =>
                                    <tr>
                                        <td style={tableRowStyle}>
                                            <div>{user.email}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            <div>{user.activated ? "Activated" : "Inactive"}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            <div>{user.bot_limit}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            <div>{user.strategy_limit}</div>
                                        </td>
                                        <td style={tableRowStyle}>
                                            <div>{calculateActiveBots(user.Bots)}</div>
                                        </td>

                                        <td style={tableRowStyle}>
                                            <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>

                                                <span><Button
                                                    onClick={() => { setSelectedUser(user); setDisplayCreateUser(true); }}
                                                    style={{ backgroundColor: "#161616", color: "white" }}>Edit</Button></span>
                                                <span><Button
                                                    onClick={() => { setDeleteUserId(user.id); setDisplayDeleteUser(true); }}
                                                    style={{ backgroundColor: "#161616", color: "white" }}>Delete</Button></span>
                                            </div>

                                        </td>
                                    </tr>)}

                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div>
            </div>
        </>
    );
};

export default User;